import { useNavigate } from "react-router-dom"

import { PanelLeftClose, PanelLeftOpen } from "lucide-react"

import { UserButton } from "@components/buttons/UserButton"
import { AccountSelection } from "@components/selections/AccountSelection"
import { ProjectSelection } from "@components/selections/ProjectSelection"

import { Breadcrumb, BreadcrumbItem, BreadcrumbList } from "@ui/breadcrumb"
import { Button } from "@ui/button"
import { Separator } from "@ui/separator"
import { useSidebar } from "@ui/sidebar"
import { useUserSession } from "@session/UserSession"

import APP_LOGO from "@/assets/nfwf-logo.png"

export function ApplicationHeader() {
    const { project } = useUserSession()

    const { state, toggleSidebar } = useSidebar()
    const navigate = useNavigate()

    const handleNavigateHome = () => {
        navigate("/")
    }

    return (
        <header className="z-50 w-full items-center border-b bg-background">
            <div className="flex h-[var(--header-height)] w-full items-center justify-between px-4">
                <div className="flex items-center gap-2 w-1/2">
                    <Button className="w-[120px]" variant="ghost" size="icon" onClick={handleNavigateHome}>
                        <img
                            src={APP_LOGO}
                            style={{ height: '36px', width: '100%' }}
                            alt="NFWF logo"
                        />
                    </Button>
                    <Separator orientation="vertical" className="h-4" />
                    <Button variant="ghost" size="icon" onClick={toggleSidebar} className="text-gray-500">
                        {state === "expanded" ? <PanelLeftClose /> : <PanelLeftOpen />}
                    </Button>
                    <Separator orientation="vertical" className="h-4" />
                    <Breadcrumb className="hidden sm:block">
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <AccountSelection />
                            </BreadcrumbItem>
                            <Separator orientation="vertical" className="h-4" />
                            <BreadcrumbItem>
                                <ProjectSelection />
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>
                </div>
                <div className="flex items-center gap-4 w-1/2 justify-end">
                    <div className="flex items-center gap-2">
                        <span className="text-sm text-red-400">Everything that is AI generated should be double checked</span>
                    </div>
                    <UserButton />
                </div>
            </div>
        </header>
    )
}
